export const SWIPE_COSTS = {
  classic: 10,
  matching: 30,
} as const;

export const FRIEND_REQUEST_COST = 10;
